import EnumObject from '@/domain/enum-object.entity';
import Currency from '@/domain/currency/entity/currency.entity';
import GenericDetailed from './billing-detailed-entitys.ts/generic-detailed.entity';
import ContractsDetailed from './billing-detailed-entitys.ts/contracts-detailed-entity';

interface InvoicePayment {
  externalId: string
}

export default class BillingListBase {
  id: string;

  invoiceNumber: string;

  customerExternalId: string;

  customerName: string;

  customerDocument: string;

  resultCenters: GenericDetailed[] = [];

  invoicePayments: InvoicePayment[] = [];

  contracts: ContractsDetailed[] = [];

  deleted: boolean;

  selected: boolean;

  customerTradingName: string;

  competenceMonth: string

  competenceYear: string;

  paymentDueAt: string;

  status: EnumObject;

  netValue: string;

  currency: Currency;

  invoiceValue: string;

  paymentPaidValue: string;

  paymentOpenValue: string;

  unexchangedValue: number;

  unexchangedPaidValue: number;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.invoiceNumber = obj.invoiceNumber;
    this.competenceMonth = obj.competenceMonth;
    this.competenceYear = obj.competenceYear;
    this.customerName = obj.customerName;
    this.customerDocument = obj.customerDocument;
    this.customerExternalId = obj.customerExternalId;
    this.paymentDueAt = obj.paymentDueAt;
    this.paymentPaidValue = obj.paymentPaidValue;
    this.paymentOpenValue = obj.paymentOpenValue;
    this.invoiceValue = obj.value;
    this.netValue = obj.netValue;
    this.customerTradingName = obj.customerTradingName;
    this.status = EnumObject.of(obj.status);
    if (obj.contracts) this.contracts = ContractsDetailed.ofList(obj.contracts);
    if (obj.resultCenters) this.resultCenters = GenericDetailed.ofList(obj.resultCenters);
    this.currency = Currency.of(obj.currency);
    this.selected = obj.selected;
    this.deleted = obj.deleted;
    if (obj.invoicePayments) this.invoicePayments = obj.invoicePayments
    this.unexchangedValue = obj.unexchangedValue
    this.unexchangedPaidValue = obj.unexchangedPaidValue
  }

  public get statusValue(): string {
    return this.status.description;
  }

  public get statusColor(): string {
    switch (this.status.value) {
      case 'PRE_BILLED':
        return '#2F80ED';
      case 'TO_RECEIVE':
        return '#F2C94C';
      case 'RECEIVED':
        return '#189F51';
      case 'DEFAULTING':
        return '#BB452C';
      case 'CANCELED':
        return '#FF3306';
      default:
        return 'black';
    }
  }

  public get isUnpaid(): boolean {
    return this.status.value === 'DEFAULTING';
  }

  get contractsJoined(): string {
    return this.contracts.map((el: ContractsDetailed) => `${el.number}`).join(', ')
  }

  get resultCentersGrouped(): string {
    const length = this.resultCenters.length;
    return length > 1 ? `${length} Itens` : this.resultCenters[0].name;
  }

  get resultCentersJoined(): string {
    return this.resultCenters.map((el: GenericDetailed) => `${el.name}`).join(', ')
  }

  get invoicePaymentsGrouped(): string {
    const length = this.invoicePayments.length;
    if (length === 0) return '';
    return length > 1 ? `${length} Itens` : this.invoicePayments[0].externalId;
  }

  get invoicePaymentsJoined(): string {
    return this.invoicePayments.map((el: InvoicePayment) => `${el.externalId}`).join(', ')
  }

  get competence() {
    return `${this.competenceMonth}/${this.competenceYear}`
  }

  get isPreInvoice(): boolean {
    return this.status.value === 'PRE_INVOICE';
  }
}
